<template>
    <div class="form-check">
        <input
            :checked="isChecked"
            :id="name"
            class="checkbox"
            type="checkbox"
            @change="onChange"
        />
        <label
            :for="name"
            class="form-check-label"
        >
            <span class="form-check-label__text">
                {{ displayedLabel }}
                <slot/>
            </span>
        </label>
        <div
            v-if="errorMessage"
            class="message message--error"
        >
            <i class="icon icon--xs icon-warning_triangle"/>
            <span>{{ errorMessage }}</span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { capitalize } from '@shared/filters';

    export default Vue.component('CustomCheckbox', {
        props: {
            value: {
                type: Boolean,
                required: false,
                default: false,
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            translateLabel: {
                type: Boolean,
                required: false,
                default: true
            },
            errorMessage: {
                type: String,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                isChecked: this.value
            };
        },
        watch: {
            value(value) {
                this.isChecked = value;
            },
        },
        computed: {
            displayedLabel() {
                return capitalize(this.translateLabel ? this.$t(this.label) : this.label);
            }
        },
        methods: {
            onChange(event) {
                this.$emit('input', event.target.checked);
                this.$emit('valueChanged', event.target.checked, this.name);
            }
        }
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/forms/CustomCheckbox.vue